<template>
<body class="dataDownBody">
    <header class="header width_total_100 animateContent dataDownAnimate1">
        <div class="w_container">
            <div class="commonTop">
                <OmpLink></OmpLink>
            </div>
            <div class="bannerPart">
                <div>
                    <div>全套Tip Biu BI知识资料</div>
                    <p>点击即可完成下载</p>
                </div>
            </div>
        </div>
    </header>
    <div class="width_total_100 proBottomBg ">
        <div class="w_container">
            <div class="dataMain">
                <ul class="clearfix">
                    <li>
                        <div class="dataMainPerLogo">
                            <div>
                                <span></span>
                                <label></label>
                            </div>
                        </div>
                        <h4>Tip Biu BI系统介绍</h4>
                        <p>“Tip Biu BI”是鼎捷推出的数据订阅类产品，可快速连接ERP系统指标、系统报表，实现视觉化的数据分析与数据的自助式服务。</p>
                        <a href="https://escloud.digiwincloud.com/static/zh-CN/file/Tip Biu BI产品介绍.pptx" download id="file-1" target="_blank" @click="fileDownload('file-1','Tip Biu BI系统介绍')"><img src="../assets/img/dataDowload_04.png" />点击下载</a>
                    </li>
                    <li>
                        <div class="dataMainPerLogo">
                            <div class="dataPerNo2">
                                <span></span>
                                <label></label>
                            </div>
                        </div>
                        <h4>Tip Biu BI操作-客户操作篇</h4>
                        <p>经由此PPT介绍，您可了解到Tip Biu BI的注册、下载、登入、使用的全过程。</p>
                        <a href="https://escloud.digiwincloud.com/static/zh-CN/file/Tip Biu BI功能培训.pptx" download id="file-2" target="_blank" @click="fileDownload('file-2','Tip Biu BI功能培训')"><img src="../assets/img/dataDowload_04.png" />点击下载</a>
                    </li>
                    <li>
                        <div class="dataMainPerLogo">
                            <div class="dataPerNo3">
                                <span></span>
                                <label></label>
                            </div>
                        </div>
                        <h4>Tip Biu BI安全白皮书</h4>
                        <p>对云数据产品有顾虑？没关系，这份资料可以为您解答所有的信息安全问题，让您放心上云。</p>
                        <a href="https://escloud.digiwincloud.com/static/zh-CN/file/Tip Biu BI安全白皮书v1.docx" download id="file-3" target="_blank" @click="fileDownload('file-3','Tip Biu BI安全白皮书v1')"><img src="../assets/img/dataDowload_04.png" />点击下载</a>
                    </li>
                    <li>
                        <div class="dataMainPerLogo">
                            <div class="dataPerNo4">
                                <span></span>
                                <label></label>
                            </div>
                        </div>
                        <h4>Tip Biu BI软硬件规格</h4>
                        <p>此文件详细阐述了安装同步器时对硬件及软件的要求。</p>
                        <a href="https://escloud.digiwincloud.com/static/zh-CN/file/Tip Biu BI软硬件规格.docx" download id="file-4" target="_blank" @click="fileDownload('file-4','Tip Biu BI软硬件规格')"><img src="../assets/img/dataDowload_04.png" />点击下载</a>
                    </li>
                    <li>
                        <div class="dataMainPerLogo">
                            <div class="dataPerNo4">
                                <span></span>
                                <label></label>
                            </div>
                        </div>
                        <h4>Tip Biu BI功能培训</h4>
                        <p>此文件详细阐述了各种功能介绍。</p>
                        <a href="https://escloud.digiwincloud.com/static/zh-CN/file/Tip Biu BI功能培训.pptx" download id="file-5" target="_blank" @click="fileDownload('file-5','Tip Biu BI功能培训')"><img src="../assets/img/dataDowload_04.png" />点击下载</a>
                    </li>
                    <li>
                        <div class="dataMainPerLogo">
                            <div class="dataPerNoMore"></div>
                        </div>
                        <h4>更多资料</h4>
                        <p>逐步完善中，敬请期待...</p>
                    </li>
                </ul>
            </div>
            <Footer></Footer>
        </div>
    </div>
    <Control></Control>
    <FreeTry :visible.sync="freeTryVisible"></FreeTry>
</body>
</template>
<script>
import OmpLink from "@/components/common/OmpLink.vue"
import Control from "@/components/common/Control.vue"
import Footer from "@/components/common/Footer.vue"
import FreeTryButton from "@/components/common/FreeTryButton.vue"
import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink, Control,Footer, FreeTryButton, FreeTry
    },
    name: 'DataDownload',
    data() {
      return {
        freeTryVisible: false
      }
    },
    mounted() {
        this.FAQTopAnimate() // 顶部动画
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'DataDownload',
            contentName : '',
            extend2: 'CN',
        })
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    methods: {
        FAQTopAnimate() {
            var dataDownAnimate_show1=1;
            $(".dataDownBody").children(".animateContent").each(function() {
                if($(this).hasClass("dataDownAnimate1") &&  parseInt(dataDownAnimate_show1)){
                    dataDownAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                }
            });
        },
        fileDownload(fileId,fileTitle) {
            this.$http.post('/backend/web/record', {
                pageName: 'DataDownload',
                contentName: JSON.stringify({id:fileId ,title: fileTitle}),
                extend1: 'file', //类别-文件
                extend2: 'CN',
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        }
    }
  }
</script>
<style scoped>
    .header{
        height: 960px;
        background: url(../assets/img/dataDowload_01.png) no-repeat center top;
    }
    .header .slog{
        font-size: 44px;
        color: white;
        font-weight: 100;
    }
    .bannerPart p {
        margin-bottom: 30px;
    }
    .dataMain{
        margin-top: -680px;
    }
    .dataMain li{
        float: left;
        width: 500px;
        height: 444px;
        background: #fff;
        padding:80px 45px;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        border-radius: 4px;
        margin-bottom: 24px;
    }
    .dataMain li:nth-child(2n+1){
        margin-right: 24px;
    }
    .dataMainPerLogo{
        width: 91px;
        height: 91px;
        background: url(../assets/img/dataDowload_02.png) no-repeat center center;
        position: relative;
        margin: 0 auto 24px;
    }
    .dataMainPerLogo div{
        position: absolute;
        width: 23px;
        height: 23px;
        left: 34px;
        top: 34px;
        overflow: hidden;
    }
    .dataMainPerLogo div span{
        float: left;
        width: 11.5px;
        height: 100%;
        background:url(../assets/img/dataDowload_03.png) no-repeat left center;
        background-size: cover;
        background-position: -5px 0px;
    }
    .dataMainPerLogo div label{
        float: left;
        width: 11.5px;
        height: 100%;
        background:url(../assets/img/dataDowload_03.png) no-repeat left center;
        background-size: cover;
        background-position: -30px 0px;
    }
    .dataMainPerLogo .dataPerNo2 label{
        background-position: -52px 0px;
    }
    .dataMainPerLogo .dataPerNo3 label{
        background-position: -74px 0px;
    }
    .dataMainPerLogo .dataPerNo4 label{
        background-position: -97px 0px;
    }
    .dataMainPerLogo div.dataPerNoMore{
        width: 36px;
        height: 8px;
        left: 27.5px;
        top: 41.5px;
        background:url(../assets/img/dataDowload_05.png) no-repeat left center;
    }
    .dataMain ul li h4{
        font-size: 20px;
        color:#141414;
        margin-bottom: 24px;
        font-weight: normal;
    }
    .dataMain ul li p{
        line-height: 28px;
        margin-bottom: 48px;
    }
    .dataMain ul li a{
        display: inline-block;
        width: 160px;
        height: 36px;
        margin: 0 auto;
        line-height: 36px;
        color: #141414;
        background: #F2F7FA;
        border: #DAE2E6 1px solid;
        -moz-border-radius: 50px;
        -webkit-border-radius: 50px;
        border-radius: 50px;
    }
    .dataMain ul li a:hover{
        opacity: 0.6;
    }
    .dataMain ul li a img{
        margin-right: 10px;
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/components/DataDownload.vue